import React from "react";
import styled from "styled-components";
import COLORS from "../styled.constants";
import { Col } from "react-bootstrap";
import {
  DiRuby,
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiGit,
  DiAngularSimple,
} from "react-icons/di";
import { SiTypescript, SiPostgresql, SiRedux, SiExpress } from "react-icons/si";

const Skills = () => {
  const Title = styled.div`
    display: flex;
    color: ${COLORS.title};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 8rem;
    /* padding: 8rem; */
    width: 100%;
    h2 {
      padding-top: 50px;
      text-transform: uppercase;
      font-size: 2em;
      padding-bottom: 1rem;
    }
    @media (max-width: 767px) {
      font-size: 0.7em;
    }
  `;

  const PlText = styled.div`
    font-size: 1.5em;
    color: ${COLORS.text};
    margin-bottom: 1rem;
    width: 100%;
    .tech-detail {
      width: 100%;
    }
    .detail-card {
      width: 100%;
      text-align: center;
    }
  `;

  const TechSection = styled.div`
    display: flex;
    justify-content: center;
    width: 80%;
    flex-wrap: wrap;
    max-width: 700px;

    /* display: grid;
    grid-template-columns: 1fr 1fr 1fr; */
    /* border: 1px solid red; */
    .tech-icons {
      font-size: 4.5em !important;
      margin: 15px !important;
      padding: 10px !important;
      opacity: 0.93 !important;
      border: 1.7px solid !important;
      vertical-align: middle !important;
      text-align: center !important;
      border-radius: 5px !important;
      display: table !important;
      box-shadow: 4px 5px 4px 3px ${COLORS.text} !important;
      overflow: hidden !important;
      transition: all 0.4s ease 0s !important;
    }

    @media (max-width: 767px) {
      .tech-icons {
        margin: 10px !important;
      }
    }

    .tech-icons:hover {
      transform: scale(1.05) !important;
      overflow: hidden !important;
      border: 2.2px solid ${COLORS.button} !important;
    }
    .tech-icon-images {
      padding: 20px !important;
      line-height: 1.6 !important;
    }
  `;

  return (
    <>
      <Title>
        <PlText>
          <div className="tech-detail">
            <div className="detail-card">Here is my current tech-stack</div>
          </div>
        </PlText>
        <h2>My ToolKit</h2>
        <TechSection>
          {/* <Row style={{ justifyContent: "center", paddingBottom: "50px" }}> */}
          <Col xs={4} md={2} className="tech-icons">
            <SiTypescript />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiJavascript1 />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiNodejs />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiReact />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiMongodb />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiAngularSimple />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiGit />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiRedux />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiRuby />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiPostgresql />
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiExpress />
          </Col>

          {/* </Row> */}
        </TechSection>
      </Title>
    </>
  );
};

export default Skills;
